import { useCallback, useState } from 'react';

export const useFilters = (values) => {
  const [filters, setFilters] = useState(values);

  const handleChange = useCallback(
    (name, value) => setFilters((prev) => ({ ...prev, [name]: value })),
    [],
  );

  return {
    filters,
    setFilters,
    handleChange,
  };
};
